import $ from 'jquery';

const Slides = () => {
    $('.home-card-slide').slick({
        dots: true,
        infinite: false,
        centerMode: true,
        focusOnSelect: true,
        responsive: [
            {
              breakpoint: 12000,
              settings: "unslick"
            },
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    });


    $('.testi-block-container').slick({
        dots: true,
        infinite: false,
    });


}

export default Slides
